export default {
  ratingRoot: 'rating-root',
};
